import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=2641fa26&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
import style0 from "./Service.vue?vue&type=style&index=0&id=2641fa26&prod&lang=scss"
import style1 from "./Service.vue?vue&type=style&index=1&id=2641fa26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641fa26",
  null
  
)

export default component.exports